// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Qv","widget":"e_Rv","title":"e_Sv","msrp":"e_Tv","separator":"e_Uv","textBadge":"e_Vv"};